export default __webpack_public_path__ + "static/media/img-16.2899cb52.jpg";